import { download } from "@/lib/exportData";
import { geodesicArea } from "@/components/map/MeasureTool";

const stamp = () => new Date().toISOString().slice(0, 10);
const kmlColor = (hex, alpha = "ff") => { const h = hex.replace("#", "").padEnd(6, "0"); return `${alpha}${h.slice(4, 6)}${h.slice(2, 4)}${h.slice(0, 2)}`; };
const esc = (s) => String(s ?? "").replace(/[<>&]/g, (c) => ({ "<": "&lt;", ">": "&gt;", "&": "&amp;" }[c]));

export const drawingToFeature = (d) => {
  const ring = d.points.map(([lat, lng]) => [lng, lat]);
  if (d.closed && (ring[0][0] !== ring[ring.length - 1][0] || ring[0][1] !== ring[ring.length - 1][1])) ring.push(ring[0]);
  return {
    type: "Feature",
    geometry: d.closed ? { type: "Polygon", coordinates: [ring] } : { type: "LineString", coordinates: ring },
    properties: { name: d.name, color: d.color, line_style: d.line_style, weight: d.weight, area_ha: d.closed ? +(geodesicArea(d.points) / 10000).toFixed(4) : null, created_at: d.created_at, note: d.note || "" },
  };
};

export function exportDrawingsGeoJSON(drawings) {
  download(JSON.stringify({ type: "FeatureCollection", name: "CG Land Geoportal boundaries", features: drawings.map(drawingToFeature) }, null, 1), `cgland-boundaries-${stamp()}.geojson`, "application/geo+json");
}

export function exportDrawingsKML(drawings) {
  const placemarks = drawings.map((d, i) => {
    const coords = d.points.map(([lat, lng]) => `${lng},${lat},0`);
    if (d.closed) coords.push(coords[0]);
    const geom = d.closed
      ? `<Polygon><outerBoundaryIs><LinearRing><coordinates>${coords.join(" ")}</coordinates></LinearRing></outerBoundaryIs></Polygon>`
      : `<LineString><coordinates>${coords.join(" ")}</coordinates></LineString>`;
    const area = d.closed ? `Area: ${(geodesicArea(d.points) / 10000).toFixed(3)} ha` : "";
    return `<Placemark><name>${esc(d.name)}</name><description>${esc(`${d.line_style} line · ${area}`)}</description><styleUrl>#s${i}</styleUrl>${geom}</Placemark>`;
  });
  const styles = drawings.map((d, i) => `<Style id="s${i}"><LineStyle><color>${kmlColor(d.color)}</color><width>${d.weight}</width></LineStyle><PolyStyle><color>${kmlColor(d.color, d.fill ? "40" : "00")}</color></PolyStyle></Style>`);
  const kml = `<?xml version="1.0" encoding="UTF-8"?>\n<kml xmlns="http://www.opengis.net/kml/2.2"><Document><name>CG Land Geoportal boundaries</name>${styles.join("")}${placemarks.join("")}</Document></kml>`;
  download(kml, `cgland-boundaries-${stamp()}.kml`, "application/vnd.google-earth.kml+xml");
}
